import React from "react";
import CustomModal from "Components/CommonComponents/CustomModal";
import VideoPlayer from "Pages/AssetView/VideoPlayer";
import PDFPageviewer from "Pages/PlannerView/PDFPageviewer";
import ErrorView from "Pages/AssetView/ErrorView";

interface AssetViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  contentType: {
    type: "video" | "ebook" | "recordedPDF" | "recordedVideo" | null;
    data: string;
  } | null;
  pdfPassword?: string | null;
  title?: string;
  assetId?: string;
}

const AssetViewerModal: React.FC<AssetViewerModalProps> = ({
  isOpen,
  onClose,
  contentType,
  pdfPassword,
  title,
  assetId,
}) => {
  console.log("contentType", contentType);
  return (
    <CustomModal
      modal={isOpen}
      centered={true}
      backdrop={true}
      size={contentType?.type === "video" ? "lg" : "xl"}
      fullscreen={true}
      className={
        contentType?.type === "ebook" || contentType?.type === "recordedPDF"
          ? "document-viewer-fullscreen-modal"
          : undefined
      }
      title={title || " "}
      toggle={onClose}
    >
      <div
        className="modern-asset-viewer-container w-100 d-flex align-items-center justify-content-center"
        style={{
          height: "100vh",
          maxHeight: "100vh",
          overflow: "hidden",
          background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
          padding:
            contentType?.type === "video" ||
            contentType?.type === "recordedVideo"
              ? "20px"
              : "0",
        }}
      >
        {contentType && contentType != null ? (
          contentType.type === "video" ||
          contentType.type === "recordedVideo" ? (
            <div className="modern-video-wrapper">
              <div className="video-player-container">
                <VideoPlayer
                  videoUrl={contentType.data}
                  JWTToken={""}
                  assetId={assetId}
                  source={
                    contentType.type === "recordedVideo" ? "CRYSTAL" : "FEX"
                  }
                />
              </div>
            </div>
          ) : contentType?.data !== "" && pdfPassword != null ? (
            <PDFPageviewer
              allPageInOne={true}
              pdfUrl={contentType?.data}
              pdfPassword={pdfPassword}
              isLibraryView={true}
              parentComponent="AssetViewerModal"
            />
          ) : (
            <ErrorView />
          )
        ) : null}
      </div>
    </CustomModal>
  );
};

export default AssetViewerModal;
